import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [secondsLeft, setSecondsLeft] = useState(15 * 60);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeString = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  const isExpired = secondsLeft <= 0;
  return <div className="mb-6 w-full" data-id="element-206">
      <div className="border border-sage rounded-xl px-6 py-5 shadow-sm text-center bg-[#F1CA8E]" data-id="element-207">
        {isExpired ? <p className="text-red-600 font-bold text-lg" data-id="element-208">Oferta expirada</p> : <>
            <p className="text-primary font-bold text-lg mb-2" data-id="element-209">
              ¡OFERTA SÓLO POR HOY!
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-4 max-w-xs mx-auto" data-id="element-210">
              Tu promoción está reservada durante 15 minutos. En caso de no
              acceder, se cederá el descuento a la siguiente persona.
            </p>
            <p className="text-3xl font-bold text-primary font-mono tracking-widest" data-id="element-211">
              {timeString}
            </p>
          </>}
      </div>
    </div>;
}